<template>
    <div class="box">
        <!-- 筛选条件 -->
        <div class="filtrate">
            <el-form ref="form" :model="form" label-width="90px" class="form" :inline="true">
                <el-form-item label="商户名称/编号" label-position="right">
                    <el-input v-model="form.merchantIdOrMerchantName" size="small" placeholder="请输入商户名称或编号"></el-input>
                </el-form-item>
            </el-form>
            <div class="query">
                <el-button type="primary" icon="el-icon-search" @click="queryFunc">查询</el-button>
                <el-button icon="el-icon-delete" @click="clearFunc">重置</el-button>
                <el-button size="small" type="success" @click="onExport">导出</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <div class="tab">
            <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }">
                <el-table-column prop="merchantNo" label="商户编号" width="180">
                </el-table-column>
                <el-table-column prop="txnTime" label="交易时间" width="180">
                </el-table-column>
                <el-table-column prop="idTxnCtrl" label="交易编码" width="180">
                </el-table-column>

                <el-table-column prop="amt" label="交易金额" width="180">
                    <template slot-scope="scope">
                        {{ scope.row.amt ? scope.row.amt : '0.00' }}
                    </template>
                </el-table-column>
              <el-table-column prop="phoneNo" label="产品" width="180">
                <template slot-scope="scope">
                  <span v-if="scope.row.receiptType == 1">ZPOS-电签</span>
                  <span v-if="scope.row.receiptType == 2">FPOS-大机</span>
                  <span v-if="scope.row.receiptType == 3">ZPOS-买断版</span>
                  <span v-if="scope.row.receiptType == 4">FPOS-买断版</span>
                  <span v-if="scope.row.receiptType == 5">和融通</span>
                  <span v-if="scope.row.receiptType == 6">合利宝</span>
                  <span v-if="scope.row.receiptType == 7">电银</span>
                  <span v-if="scope.row.receiptType == 8">联动支付</span>
                </template>
              </el-table-column>
                <el-table-column prop="status" label="交易状态">
                    <template slot-scope="scope">
                      <span v-if="scope.row.status == '1'">成功</span>
                      <span v-if="scope.row.status == '2'">失败</span>
                    </template>
                </el-table-column>
                <el-table-column prop="merchantIdFee" label="手续费（元）">
                    <template slot-scope="scope">
                        {{ scope.row.merchantIdFee ? scope.row.merchantIdFee : '0.00' }}
                    </template>
                </el-table-column>
                <el-table-column prop="tradeType" label="交易类型">
                    <template slot-scope="scope">
                      <span v-if="scope.row.tradeType == '1'">刷卡</span>
                      <span v-if="scope.row.tradeType == '2'">扫码支付</span>
                    </template>
                </el-table-column>
                <el-table-column prop="cardType" label="卡类型">
                    <template slot-scope="scope">
                      <span v-if="scope.row.cardType == '0001'">贷记卡</span>
                      <span v-if="scope.row.cardType == '0002'">借记卡</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="paginationBox">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagelndex" :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper"
                :total="total" class="pagination">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import merchantApi from '@/api/merchant/realtimetrade.js';
import {getCookie} from '@/utils/base.js';
import qs from "qs";
export default {
    data() {
        return {
            form: {
                merchantIdOrMerchantName: '', // 商户名称/编号
            },
            tableData: [],
            loading: true, // 表格加载
            total: 0, // 总数
            pageSize: 10, // 条数
            pagelndex: 1, // 页数
        }
    },
    methods: {
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.realtimetradeListFunc();
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.pageIndex = val;
            this.realtimetradeListFunc();
        },
        // 渲染列表
        realtimetradeListFunc() {
            // console.log(this.pageSize)
            const params = {
                merchantIdOrMerchantName: this.form.merchantIdOrMerchantName,
                pageSize: this.pageSize,
                pageIndex: this.pageIndex,
            }
            // console.log(params.pageIndex)
            // console.log({ ...params })
            // console.log('查询', merchantIdOrMerchantName);
            merchantApi.getRealtimetrade({ ...params }).then(res => {
                // console.log(res)
                this.tableData = res.data.records;
                this.total = res.data.total
                // console.log(res);
                this.loading = false;
            }).catch(err => {
                // console.log(err);
            })
        },

        // 查询按钮
        queryFunc() {
            // console.log('输入框：', this.form.name)
            this.realtimetradeListFunc();
        },
        // 重置
        clearFunc() {
            this.form.merchantIdOrMerchantName = '';
            this.realtimetradeListFunc();
        },
        onExport: function() {
          let self = this;
          const Params = {
            merchantIdOrMerchantName: self.form.merchantIdOrMerchantName,
          }
          Params.token = getCookie('token');
          let baseUrl = window.location.protocol + '//' + window.location.host;
          window.location.href = baseUrl + '/api/shop/posConsumptionRecords/posConsumptionRecords/dealExport?' + qs.stringify(Params);
        },
    },
    mounted() {
        this.realtimetradeListFunc();
    }
}
</script>

<style scoped>
.query {
    margin: 20px 0 0 30px;
}

.tab {
    padding: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/merchant/realtimetrade/index.vue